export const GET_USERS_BY_COMPANY_QUERY = `
  query GetUsersByCompany($companyId: Int!) {
    users(where: { company_id: { _eq: $companyId } }, order_by: { created_at: desc }) {
      id
      first_name
      last_name
      email
      phone_number
      work_phone_number
      user_birthday
      address
      role
      work_start_date
      work_end_date
      annual_leave_balance
      company_id
      title_id
      team_id
      created_at
      updated_at
      company {
        id
        name
      }
      title {
        id
        title_name
      }
      user_firms {
        id
      }
      team {
        id
        name
        team_tags {
          id
          tag_id
          tag {
            id
            name
            tags_color
            tags_page
          }
        }
      }
    }
  }
`;

export const GET_ALL_USERS_QUERY = `
  query GetAllUsers($where: users_bool_exp, $limit: Int, $offset: Int, $order_by: [users_order_by!] = [{ created_at: desc }]) {
    users_aggregate(where: $where) {
      aggregate { count }
    }
    users(where: $where, order_by: $order_by, limit: $limit, offset: $offset) {
      id
      first_name
      last_name
      email
      phone_number
      work_phone_number
      user_birthday
      address
      role
      work_start_date
      work_end_date
      annual_leave_balance
      company_id
      title_id
      is_expense_manager
      is_loan_request_manager
      manages_collections
      can_view_communication_report
      team_id
      created_at
      updated_at

      team {
        id
        name
        team_tags {
          id
          tag_id
          tag {
            id
            name
            tags_color
            tags_page
          }
        }
      }
      company {
        id
        name
      }
      title {
        id
        title_name
      }
      user_firms {
        id
      }
    }
  }
`;

export const GET_COMPANIES_FOR_USER_FORM_QUERY = `
  query GetCompaniesForUserForm {
    companies {
      id
      name
    }
  }
`;

export const GET_AVAILABLE_USERS_FOR_TEAM_QUERY = `
  query GetAvailableUsersForTeam($companyId: Int, $excludeTeamId: Int) {
    users(where: { 
      company_id: { _eq: $companyId },
      _or: [
        { team_id: { _is_null: true } },
        { team_id: { _neq: $excludeTeamId } }
      ]
    }, order_by: { first_name: asc }) {
      id
      first_name
      last_name
      email
      role
      company_id
      team_id
      team {
        id
        name
        team_manager_id
      }
      company {
        id
        name
      }
    }
  }
`;

export const GET_ALL_AVAILABLE_USERS_FOR_TEAM_QUERY = `
  query GetAllAvailableUsersForTeam($excludeTeamId: Int) {
    users(where: { 
      _or: [
        { team_id: { _is_null: true } },
        { team_id: { _neq: $excludeTeamId } }
      ]
    }, order_by: { first_name: asc }) {
      id
      first_name
      last_name
      email
      role
      company_id
      team_id
      team {
        id
        name
        team_manager_id
      }
      company {
        id
        name
      }
    }
  }
`;
